import React from "react";
import { useNavigate } from "react-router-dom";

const Sidenav = () => {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 800;
  const imgPath = process.env.PUBLIC_URL + "/image/side/";
  const images = [
    {
      name: isMobile ? "moside1" : "side1",
      onClick: () => (window.location.href = "http://eplusdentistry.com/"),
    },
    {
      name: isMobile ? "moside2" : "side2",
      onClick: () => (window.location.href = "http://pf.kakao.com/_IFSln/chat"),
    },
    { name: isMobile ? "moside3" : "side3", onClick: () => navigate("/as") },
    {
      name: isMobile ? "moside4" : "side4",
      onClick: () =>
        (window.location.href =
          "https://booking.naver.com/booking/13/bizes/1164401"),
    },
    {
      name: isMobile ? "moside5" : "side5",
      onClick: () => (window.location.href = "tel:032-565-7528"),
    },
    {
      name: isMobile ? "moside6" : "side6",
      onClick: () => window.scrollTo({ top: 0, behavior: "smooth" }),
    },
  ];

  return (
    <div className="sidenav-container-xyz123">
      {images.map((image, index) => (
        <img
          key={index}
          src={`${imgPath}${image.name}.png`}
          alt={image.name}
          className="sidenav-image-abc456"
          onClick={image.onClick}
        />
      ))}
      <style jsx>{`
        .sidenav-container-xyz123 {
          position: fixed;
          bottom: 200px;
          right: 0px;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          background-color: white;
        }
        .sidenav-image-abc456 {
          margin-bottom: 0px;
          width: 120px;
        }
        @media (max-width: 800px) {
          .sidenav-container-xyz123 {
            background-color: transparent;
            right: 17px;
          }
          .sidenav-image-abc456 {
            width: 50px;
            margin-bottom: 5px;
          }
        }

         {
          /* 팝업 오류 ? */
        }

        .popup {
          position: absolute;
          top: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          z-index: 1000;
          background: #fff;
          border: 1px solid #ccc;
          border-left: none;
        }
        .feb-event-popup {
          width: 500px;
          left: 0;
        }
        .do-my-best-popup {
          width: 600px;
          left: 500px;
        }
        .do-my-best-popup img {
          width: 600px;
        }
        .controls-container {
          display: flex;
          justify-content: space-between;
          width: 100%;
          font-size: 12px;
          border: 1px solid #ccc;
        }
        .closePopup {
          background-color: white;
          border: none;
          color: black;
        }
        @media (max-width: 800px) {
          .popup {
            width: 90% !important;
            left: 5% !important;
            top: 100px !important;
          }
          .do-my-best-popup img {
            width: 440px;
          }
        }
      `}</style>
    </div>
  );
};

export default Sidenav;
